import { useRef } from "react";
import Chart from "react-apexcharts";

type PieChartProps = {
  options: any;
};

export default function LineChart({ options }: PieChartProps) {
  return (
    <div className="line font-readex">
      {!!options && (
        <Chart
          options={options.options}
          series={options.series}
          width={"100%"}
          height={300}
          type="line"
        />
      )}
    </div>
  );
}
